<div class="main-content" [ngClass]="alayticsService.currentTheme === 'material-dark' ? 'dark-theme' : ''">
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    size="small"
    [disableAnimation]="false"
    *ngIf="(router.url.includes('student-dashboard') || router.url.includes('parent-dashboard')) && isExpand"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>
  <div class="d-flex justify-content-between" *ngIf="isExpand">
    <div></div>

    <nb-card class="cursor-pointer classroom-details">
      <nb-card-body>
        <div class="d-flex justify-content-between">
          <div class="classroom-name-content text-left">
            <h5 class="classroom-name quicksand-bold-label">
              {{ classroom?.name }}
            </h5>

            <div class="classroom-subject quicksand-bold-label">
              {{ classroom?.subject | uppercase }}
            </div>
          </div>

          <div class="d-flex" style="margin-right: -5px">
            <div class="classroom-code text-center">
              {{ classroom?.code }}
            </div>
          </div>
        </div>
      </nb-card-body>
    </nb-card>

    <div class="text-right mb-3 btn-close-content">
      <button class="btn-close" (click)="closeDialog()">
        <nb-icon icon="collapse" class="icon-close-expand-view"></nb-icon>
      </button>
    </div>
  </div>

  <ng-container>
    <div
      class="pagination d-flex justify-content-end quicksand-bold-label mb-3"
      *ngIf="currentPage !== 1 || studentLessonPlans?.length > 0"
    >
      <span class="quicksand-bold-label mt-2">{{ currentPage }} / {{ totalPages }}</span>
      <button
        class="btn-paginate mr-2 ml-2 quicksand-bold-label"
        (click)="currentPage = currentPage - 1; getStudentLessonPlanByPage()"
        [disabled]="currentPage === 1"
      >
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </button>

      <button
        class="btn-paginate quicksand-bold-label"
        (click)="currentPage = currentPage + 1; getStudentLessonPlanByPage()"
        [disabled]="currentPage === totalPages"
      >
        <nb-icon icon="arrow-forward-outline"></nb-icon>
      </button>
    </div>
  </ng-container>

  <!-- web view -->
  <div
    class="col-md-12 lesson-plan-content p-0"
    *ngIf="studentLessonPlans && studentLessonPlans.length > 0 && !isMobileScreen"
  >
    <table class="table table-border-radius">
      <thead>
        <tr>
          <th class="quicksand-bold-label {{ isExpand ? 'font-lg-sz' : 'font-sm-sz' }} table-header-row" scope="col">
            Section Id
          </th>
          <th class="quicksand-bold-label {{ isExpand ? 'font-lg-sz' : 'font-sm-sz' }} table-header-row" scope="col">
            Section Title
          </th>
          <th class="quicksand-bold-label {{ isExpand ? 'font-lg-sz' : 'font-sm-sz' }} table-header-row" scope="col">
            Start Time
          </th>
          <th class="quicksand-bold-label {{ isExpand ? 'font-lg-sz' : 'font-sm-sz' }} table-header-row" scope="col">
            End Time
          </th>
          <th class="table-header-row"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="quicksand-bold-label cursor-pointer {{ isExpand ? 'font-lg-sz' : 'font-sm-sz' }}"
          *ngFor="let studentLessonPlan of studentLessonPlans"
          (click)="renderToLessonPlan(studentLessonPlan)"
        >
          <td class="quicksand-bold-label {{ isExpand ? 'font-lg-sz' : 'font-sm-sz' }}">
            {{ studentLessonPlan.plan.section_id }}
          </td>
          <td>
            {{ studentLessonPlan.plan.section_title }}
          </td>
          <td class="quicksand-bold-label {{ isExpand ? 'font-lg-sz' : 'font-sm-sz' }}">
            {{ studentLessonPlan.start | date : 'MMM d, y, h:mm:ss a' }}
          </td>
          <td class="quicksand-bold-label {{ isExpand ? 'font-lg-sz' : 'font-sm-sz' }}">
            {{ studentLessonPlan.end | date : 'MMM d, y, h:mm:ss a' }}
          </td>
          <td>
            <nb-icon icon="arrow-forward-outline" class="mt-1 arrow-forward-icon"></nb-icon>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- mobile-view -->
  <div class="lesson-plan-card-view" *ngIf="studentLessonPlans && studentLessonPlans.length > 0 && isMobileScreen">
    <nb-card *ngFor="let studentLessonPlan of studentLessonPlans" (click)="renderToLessonPlan(studentLessonPlan)">
      <nb-card-body>
        <div class="title">Section Id:</div>
        <div class="value mb-2">
          {{ studentLessonPlan.plan.section_id }}
        </div>
        <div class="title">Section Title:</div>
        <div class="value mb-2">
          {{ studentLessonPlan.plan.section_title }}
        </div>

        <div class="title">Start Time:</div>
        <div class="time mb-2">
          {{ studentLessonPlans[0]?.start | date : 'MMM d, y, h:mm:ss a' }}
        </div>

        <div class="title">End Time:</div>
        <div class="time">
          {{ studentLessonPlans[0]?.end | date : 'MMM d, y, h:mm:ss a' }}
        </div>
      </nb-card-body>
    </nb-card>
  </div>
  <div
    class="col-md-12 text-center no-lession-margin quicksand-bold-label"
    *ngIf="studentLessonPlans && studentLessonPlans.length === 0"
  >
    <img src="../../../../../assets/images/respond-edu.svg" alt="responed-edu" height="100" width="100" />
    <div class="mt-2"></div>
    No Lessons Found!
  </div>
</div>
